module.exports = __webpack_public_path__ + "images/charge-gift-9134bd8dc8e4f085f13af24b7e2c224b.png";